import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';
import FormInput from '../Components/ReactHookFormCustom/FormInput';
import { changePassword } from '../Services/userService';
import useAuthStore from '../../../stores/authStore';

const ChangePasswordForm = () => {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);
  const { handleSubmit, control, reset, watch } = useForm({});
  const password = watch('newPassword');

  const handleValidAccountSubmit2 = (values, event) => {
    changePassword(values).then(({ data: user }) =>
      reset({
        originalPassword: '',
        newPassword: '',
        retypedPassword: '',
      })
    );
  };

  return (
    <div className="row">
      <div className="card b col-xl-6">
        <div className="card-header bg-gray-lighter text-bold">{t('common.CHANGE_PASSWORD')}</div>
        <div className="card-body">
          <form onSubmit={handleSubmit(handleValidAccountSubmit2)}>
            <Row className="pb-3">
              <Col>
                <FormInput
                  name="originalPassword"
                  id="originalPasswordId"
                  label={t('common.PASSWORD')}
                  type="password"
                  control={control}
                  rules={{
                    required: t('common.REQUIRED'),
                  }}
                />
              </Col>
            </Row>
            <Row className="pb-3">
              <Col>
                <FormInput
                  name="newPassword"
                  id="newPasswordId"
                  label={t('common.NEW_PASSWORD')}
                  type="password"
                  control={control}
                  rules={{
                    required: t('common.REQUIRED'),
                  }}
                />
              </Col>
            </Row>
            <Row className="pb-3">
              <Col>
                <FormInput
                  name="retypedPassword"
                  id="retypedPasswordId"
                  label={t('common.RETYPE_PASSWORD')}
                  type="password"
                  control={control}
                  rules={{
                    required: t('common.REQUIRED'),
                    validate: (value) => value === password || t('common.RETYPE_PASSWORD_ERR_MISMATCH_MSG'),
                  }}
                />
                {user.role === 'Admin' ? (
                  <p className="text-warning">TODO: admin can not yet change password for other users!</p>
                ) : null}
              </Col>
            </Row>
            <Button color="info" type="submit">
              {t('common.UPDATE_PASSWORD')}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
